import { bus } from '../bus'

import OrderModel from './model/Order'
import OrderWindow from './windows/OrderWindow'

export default {
	async open(comp, item) {
		var self 	= comp;
		var ent 	= item.id ? await OrderModel.read(self.axios, item.id) : OrderModel.entity();

		if (!item.id) {
			ent.employee_id 		= self.$store.state.employee.id;
			ent.department_id 		= self.$store.state.employee.department_id;
			ent._embedded.employee	= self.$store.state.employee;
		}

		self.$store.state.windowStack.push(OrderWindow, {
			value: ent,
			async submit(entity, invoice = false, paid = false) {
				if (await OrderModel.save(self.axios, entity, invoice, paid)) {
					self.$store.state.windowStack.pop();
					bus.$emit('update');
				}
			}
		});
	}
};